import { render, staticRenderFns } from "./edit-self.vue?vue&type=template&id=9febc03e&"
import script from "./edit-self.vue?vue&type=script&lang=js&"
export * from "./edit-self.vue?vue&type=script&lang=js&"
import style0 from "./edit-self.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports